import moment from "moment";

export const convertOperToBackendFormat = (oper) => {
  switch (oper) {
    case "eşittir":
      return "EQ";
    case "eşit değildir":
      return "NOT_EQ";
    case "içeren":
      return "CONTAINS";
    case "ile başlayan":
      return "STARTS";
    case "ile biten":
      return "ENDS";
    case "küçüktür":
      return "LESS";
    case "küçük ve eşittir":
      return "LESS_EQ";
    case "büyüktür":
      return "GRE";
    case "büyük ve eşittir":
      return "GRE_EQ";
    default:
      return null;
  }
};

export function formatNullData(data) {
  if (data == null) {
    return "-";
  } else return data;
}

export function getElementsByClassNameAndDefineClass(
  classnameToFind,
  classnameToBeAssigned
) {
  let element = document.getElementsByClassName(classnameToFind)[0];
  if (element) {
    element.className = classnameToBeAssigned;
  }
}

export function closeSpinner() {
  if (data == null) {
    return "-";
  } else return data;
}

export function getNestedValueFromPath(valObject, path, defaultValue = null) {
  if (!valObject || !path) return defaultValue;

  if (typeof path !== "string") {
    console.warn(
      "Warning in utils.getNestedValueFromPath func. path is not a string!"
    );
    return defaultValue;
  }

  if (path.indexOf(".") > -1) {
    let array = path.split(".");
    let i = 0;
    let result = valObject;

    while (i < array.length) {
      if (result) {
        result = result[array[i]];
      } else {
        return defaultValue;
      }

      i++;
    }

    return result !== null && result !== undefined ? result : defaultValue; // result || defaultValue;
  } else
    return valObject[path] !== null && valObject[path] !== undefined
      ? valObject[path]
      : defaultValue; // valObject[path] || defaultValue;
}

export function formatListWithParameter(data, filterParameter) {
  if (data != null && Array.isArray(data)) {
    let colItem = "-";
    data.map((x) => {
      if (data.indexOf(x) === 0) {
        colItem = x[filterParameter];
      } else {
        colItem = colItem + ", " + x[filterParameter];
      }
    });
    return colItem;
  } else return "-";
}

export function formatCompanyList(data, str, arr) {
  return data[arr].reduce((previous, current, index) => {
    return previous + (index > 0 ? ', ' : '') + current.company.name;
  }, (data[str] ? data[str] + (data[arr] && data[arr].length > 0 ? ', ' : '') : ''));
}

export function formatFileTypeList(data, str) {
  if (data != null) {
  return data.map((x) => x[str].dosyaTuru).join(", ");
  } else return "-";
}

export function getValueWithParameter(data, param) {
  if (data) {
    return data[param];
  } else return "-";
}

export function formatShortDate(val) {
  if (val != null) {
    let tempDate = moment(val).format("DD.MM.YYYY");
    return tempDate;
  } else return "-";
}

export function formatTrueFalse(val) {
  if (val === null) {
    return "Ayarlanmadı";
  } 
  else if(val === true) {
    return "Aktif";
  }
  else if(val === false) {
    return "Pasif";
  }
}

export function formatDate(val) {
  if (val != null) {
    let tempDate = moment(val).format("DD.MM.YYYY HH:mm");
    return tempDate;
  } else return "-";
}

export function formatDateNonTime(val) {
  if (val != null) {
    let tempDate = moment(val).format("DD.MM.YYYY");
    return tempDate;
  } else return "-";
}

export function formatTime(val) {
  if (val != null) {
    let tempDate = moment(val).format("HH:mm");
    return tempDate;
  } else return "-";
}

export function formatmarkInfo(val) {
  if (val === true) {
    let markInfo = "*";
    return markInfo;
  } else return "-";
}

// function formatNumber(n) {
//   // format number 1000000 to 1,234,567
//   return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// }

// export const formatCurrency = (e) => {
//   let input_val = e.target.value.toString();

//   if (input_val === "") {
//     return "";
//   }

//   if (input_val.indexOf(".") >= 0) {
//     let decimal_pos = input_val.indexOf(".");

//     let left_side = input_val.substring(0, decimal_pos);
//     let right_side = input_val.substring(decimal_pos);

//     left_side = formatNumber(left_side);

//     right_side = formatNumber(right_side);
//     right_side = right_side.substring(0, 2);

//     input_val = left_side + "." + right_side;
//   } else {
//     input_val = formatNumber(input_val);
//     input_val += ".00";
//   }

//   e.target.value = input_val;
// };

function formatNumber(n) {
  // format number 1000000 to 1,234,567
  return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatCurrency(e, blur) {
  // appends $ to value, validates decimal side
  // and puts cursor back in right position.

  // get input value
  var input_val = e.target.value;
  // don't validate empty input
  if (input_val === "") {
    return;
  }

  // original length
  // var original_len = input_val.length;

  // initial caret position
  // var caret_pos = input.getAttribute("selectionStart");

  // check for decimal
  if (input_val.indexOf(".") >= 0) {
    // get position of first decimal
    // this prevents multiple decimals from
    // being entered
    var decimal_pos = input_val.indexOf(".");

    // split number by decimal point
    var left_side = input_val.substring(0, decimal_pos);
    var right_side = input_val.substring(decimal_pos);

    // add commas to left side of number
    left_side = formatNumber(left_side);

    // validate right side
    right_side = formatNumber(right_side);

    // On blur make sure 2 numbers after decimal
    if (blur === "blur") {
      right_side += "00";
    }

    // Limit decimal to only 2 digits
    right_side = right_side.substring(0, 2);

    // join number by .
    input_val = left_side + "." + right_side;
  } else {
    // no decimal entered
    // add commas to number
    // remove all non-digits
    input_val = formatNumber(input_val);
    input_val = input_val;

    // final formatting
    if (blur === "blur") {
      input_val += ".00";
    }
  }

  // send updated string to input
  return input_val;

  // put caret back in the right position
  // var updated_len = input_val.length;
  // caret_pos = updated_len - original_len + caret_pos;
  // input[0].setSelectionRange(caret_pos, caret_pos);
}

export function formatCurrencyWithDouble(value, blur) {
  let input_val = value.toString();
  // don't validate empty input
  if (input_val === "") {
    return;
  }

  // original length
  // var original_len = input_val.length;

  // initial caret position
  // var caret_pos = input.getAttribute("selectionStart");

  // check for decimal
  if (input_val.indexOf(".") >= 0) {
    // get position of first decimal
    // this prevents multiple decimals from
    // being entered
    var decimal_pos = input_val.indexOf(".");

    // split number by decimal point
    var left_side = input_val.substring(0, decimal_pos);
    var right_side = input_val.substring(decimal_pos);

    // add commas to left side of number
    left_side = formatNumber(left_side);

    // validate right side
    right_side = formatNumber(right_side);

    // On blur make sure 2 numbers after decimal
    if (blur === "blur") {
      right_side += "00";
    }

    // Limit decimal to only 2 digits
    right_side = right_side.substring(0, 2);

    // join number by .
    input_val = left_side + "." + right_side;
  } else {
    // no decimal entered
    // add commas to number
    // remove all non-digits
    input_val = formatNumber(input_val);
    input_val = input_val;
  }

  // send updated string to input
  return input_val;

  // put caret back in the right position
  // var updated_len = input_val.length;
  // caret_pos = updated_len - original_len + caret_pos;
  // input[0].setSelectionRange(caret_pos, caret_pos);
}
export function truncateText(str, maxLength, length) {
  if(str){
    return str.length > maxLength ? str.substring(0, length) + "..." : str;
  }else{
    return str
  }

}